import { useMemo, useCallback } from "react" // 추가
import Echart from "echarts-for-react"
import { leakChartStore } from "@/routes/org/_components/modal/leak-chart-store"

const LeakChart = ({ xLabels = [], series = [], height, hideToolbar = false }) => {
  const { setRange, setSummary } = leakChartStore()
  // 1. 차트 옵션을 메모이제이션하여 불필요한 리렌더링 및 줌 초기화 방지
  const option = useMemo(() => {
    if (!xLabels.length || !series.length) return null

    return {
      tooltip: {
        trigger: "axis",
        formatter: (params) => {
          let result = `<div style="font-weight: bold margin-bottom: 4px;">${params[0].name}</div>`
          params.forEach((item) => {
            const color = item.borderColor || item.color
            const value = item.value.toLocaleString()

            result += `
              <div style="display: flex; align-items: center; justify-content: space-between; gap: 10px;">
                <span style="display: flex; align-items: center;">
                  <span style="display:inline-block; margin-right:5px; border-radius:10px; width:10px; height:10px; background-color:${color};"></span>
                  ${item.seriesName}
                </span>
                <span style="font-weight: bold;">${value} "m³"</span>
              </div>
            `
          })
          return result
        }
      },
      dataZoom: hideToolbar
        ? undefined
        : [
            { type: "inside" },
            {
              type: "slider",
              height: 15,
              bottom: 15,
              showDetail: false,
              showDataShadow: false,
              handleSize: 40,
              handleStyle: { color: "#182a87", borderWidth: 0 },
              backgroundColor: "#f1f1f1",
              fillerColor: "#4caefe33",
              borderColor: "transparent",
              brushSelect: false,
              moveHandleSize: 0
            }
          ],
      legend: { top: 0 },
      grid: {
        left: "5%",
        right: "2%",
        bottom: hideToolbar ? 10 : 40,
        top: 30,
        containLabel: true
      },
      xAxis: {
        type: "category",
        data: xLabels,
        boundaryGap: false,
        axisLabel: { rotate: 40, interval: "auto", hideOverlap: true }
      },
      yAxis: { type: "value" },
      series: series.map((s) => ({
        name: s.name,
        type: "line",
        data: s.data,
        smooth: true,
        showSymbol: false,
        symbol: "circle",
        itemStyle: { color: "#fff", borderColor: s.color, borderWidth: 2 },
        lineStyle: { width: 2, color: s.color },
        areaStyle: s.color === "#ED561B" ? { color: s.color, opacity: 0.08 } : null
      }))
    }
  }, [xLabels, series, hideToolbar])

  // 2. 이벤트 핸들러 메모이제이션
  const onDataZoom = useCallback(
    (params) => {
      const zoom = params.batch?.[0] || params
      const start = Math.floor((zoom.start / 100) * xLabels.length)
      const end = Math.ceil((zoom.end / 100) * xLabels.length)

      setRange(start, end, xLabels)

      const usage = series[0]?.data.slice(start, end).reduce((a, b) => a + b, 0) || 0
      const leak = series[1].data.slice(start, end).reduce((a, b) => a + b, 0) || 0

      setSummary({ usage, leak })
    },
    [xLabels, series, setRange, setSummary]
  )

  if (!xLabels.length || !series.length) return null

  return (
    <Echart
      className="w-full h-full max-h-full"
      style={{ height: height ?? 400 }}
      option={option}
      onEvents={{ datazoom: onDataZoom }}
    />
  )
}

export default LeakChart
